/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useMemo, useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import { useParams, useNavigate } from "react-router-dom";
import {
  getCarLoanById,
  updateCarLoan,
  getAllAdmins,
  getAllCities,
  getCarLoanByMobile,
  getAllStates,
  getAllPincode,
  getCarLoanByEmail,
} from "../../../middleware/backend_hepler";
import LabeledInput from "../../../components/LabeledInput";
import LabeledSelect from "../../../components/LabeledSelect";
import LabeledSelectAgent from "../../../components/LabeledSelectAgent";
import LabeledDropDown from "../../../components/LabeledDropDown";
import { Stepper, Step, StepLabel } from "@mui/material";
import { Row, Col, Button } from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import { validationRules } from "../../../utils/validationRules";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../components/Loader";


const EditCarLoan = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [viewImage, setViewImage] = useState(null);
  const [imageType, setImageType] = useState(null);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [pincodenumber, setPincode] = useState([]);
  const [pincodeOptions, setPincodeOptions] = useState([]);
  const [error, setError] = useState(null);
  const [emailExists, setEmailExists] = useState(false);
  const [initialEmail, setInitialEmail] = useState("");
  const [mobileExists, setMobileExists] = useState(false);
  const [initialMobile, setInitialMobile] = useState("");
  const { adminRole, adminName, adminId } = useContext(AuthContext);
  const [status, setStatus] = useState("");

  const steps = ["Personal Details", "Loan Details", "Upload Documents"];

  const methods = useForm({
    defaultValues: {
      created_id: "",
      created_by: "",
      assigned_to: "",
      status: "",
      rejected_reason: "",
      employee_type: "",
      name: "",
      dob: "",
      email: "",
      mobile: "",
      maritalstatus: "",
      current_address: "",
      city: "",
      state: "",
      pincode: "",
      emergency_contact_phone: "",
      current_bank_name: "",
      branch: "",
      account_type: "",
      account_number: "",
      own_house: "",
      current_loan: "",
      monthly_income: "",
      make_model: "",
      registered_month: "",
      registered_year: "",
      registration_number: "",
      loan_type: "",
      requested_loan_amount: "",
      pan_card: null,
      aadhar_card: null,
      photo: null,
      signature: null,
      cosigner_signature: null,
    },
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
    reset,
  } = methods;
  const email = watch("email");
  const mobile = watch("mobile");

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };

  useEffect(() => {
    const fetchCities = async () => {
      setLoading(true);
      setError(null);

      try {
        const citiesData = await getAllCities();
        console.log("Fetched cities data:", citiesData);
        const tamilNaduCities = citiesData
          .filter((city) => city.State_name === "Tamil Nadu")
          .sort((a, b) => a.name.localeCompare(b.name));
        
        setCities(tamilNaduCities);
        setLoading(true);
        const options = tamilNaduCities.map((city) => ({
          value: city.name,
          label: city.name,
        }));
        setCityOptions(options);
      } catch (error) {
        console.error("Error fetching cities:", error);
        setError("Failed to load cities data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    
    fetchCities();
  }, []);
  
  useEffect(() => {
    const fetchStates = async () => {
      setLoading(true);
      setError(null);
      try {
        const statesData = await getAllStates();
        const availableStates = statesData.filter(
          (state) => state.availability === "Yes"
        );
        setStates(availableStates);

        localStorage.setItem("statesData", JSON.stringify(availableStates));
      } catch (error) {
        console.error("Error fetching states data:", error);
        setError("Failed to load states data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchStates();
  }, []);

  const stateOptions = useMemo(
    () =>
      states.map((state) => ({
        value: state.name,
        label: state.name,
      })),
    [states]
  );

  useEffect(() => {
    const fetchPinCode = async () => {
      setLoading(true);
      setError(null);
      try {
        const pincodeData = await getAllPincode();
        const tamilNaduStates = pincodeData
          .filter((pincode) => pincode.state === "TAMIL NADU")
          .sort((a, b) => Number(a.pincode) - Number(b.pincode));
        const uniquePincodes = Array.from(
          new Set(tamilNaduStates.map((p) => p.pincode))
        );
        setPincode(uniquePincodes);
        setPincodeOptions(
          uniquePincodes.map((pincode) => ({
            value: pincode,
            label: pincode,
          }))
        );
      } catch (error) {
        console.error("Error fetching pincodes:", error);
        setError("Failed to load pincode data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    fetchPinCode();
  }, []);

    useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await getAllAdmins();
        const filteredEmployees = response.filter(
          (admin) => admin.role === "employee"
        );
        setEmployees(filteredEmployees);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching employees:", error);
      }
    };

    fetchEmployees();
  }, []);

  useEffect(() => {
    const fetchLoanData = async () => {
      try {
        const loan = await getCarLoanById(id);
        Object.keys(loan).forEach((key) => {
          setValue(key, loan[key]);
        });
        setInitialEmail(loan.email);
        setInitialMobile(loan.mobile);
      } catch (error) {
        console.error("Error fetching car loan data:", error);
      }
    };

    fetchLoanData();
  }, [id, setValue]);

  const checkEmail = async (email) => {
    if (email && email !== initialEmail) {
      try {
        const data = await getCarLoanByEmail(email);
        setEmailExists(Boolean(data));
      } catch (error) {
        setEmailExists(false);
      }
    } else {
      setEmailExists(false);
    }
  };

  useEffect(() => {
    if (email) {
      checkEmail(email);
    }
  }, [email]);

  const checkMobile = async (mobile) => {
    if (mobile && mobile !== initialMobile) {
      try {
        const data = await getCarLoanByMobile(mobile);
        setMobileExists(Boolean(data));
      } catch (error) {
        setMobileExists(false);
      }
    } else {
      setMobileExists(false);
    }
  };

  useEffect(() => {
    if (mobile) {
      checkMobile(mobile);
    }
  }, [mobile]);

  const getInitials = (name) => {
    if (!name) return "";
    const names = name.split(" ");
    const initials = names.map((n) => n.charAt(0).toUpperCase()).join("");
    return initials;
  };

  const employeeOptions = employees.map((employee) => ({
    value: `ID${employee.id} - ${employee.name}`,
    label: (
      <div className="agent-option">
        {employee.photo ? (
          <img
            src={decodeURIComponent(employee.photo)}
            alt={`${employee.name}'s avatar`}
            className="agent-image"
          />
        ) : (
          <div className="agent-image-initials">{getInitials(employee.name)}</div>
        )}
        <span className="agent-details">
          <strong>ID{employee.id}</strong> - {employee.name}
        </span>
      </div>
    ),
  }));

  const onSubmit = async (data) => {
    const formDataToSend = new FormData();
    Object.keys(data).forEach((key) => {
      if (data[key]) {
        formDataToSend.append(key, data[key]);
      }
    });

    try {
      await updateCarLoan(id, formDataToSend);
      navigate("/carloanlist", {
        state: { successMessage: "Car loan updated successfully!" },
      });
    } catch (error) {
      const errorMessage = error.response?.data?.message;
  
      if (typeof errorMessage === 'string') {
        if (errorMessage.includes("Email already exists")) {
          toast.error("Email already exists. Please use a different email.");
        }
        if (errorMessage.includes("Mobile number already exists")) {
          toast.error("Mobile number already exists. Please use a different mobile number.");
        }
        // In case both are mentioned in a single message
        if (errorMessage.includes("Mobile number or email already exists")) {
          toast.error("Mobile number or email already exists. Please use different details.");
        }
      } else {
        console.error("Error updating car loan:", error);
        toast.error("Failed to update the car loan. Please try again.");
      }
    }
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files.length > 0) {
      setValue(name, files[0]);
    }
  };

  const handleViewClick = async (documentType) => {
    try {
      const loan = await getCarLoanById(id);
      let url = loan[documentType];

      if (url) {
        url = decodeURIComponent(url);
        window.open(url, "_blank");
      }
    } catch (error) {
      console.error(`Error fetching ${documentType} image:`, error);
    }
  };

  const handleStepChange = async (newStep) => {
    if (newStep === 1) {
      const isValidStep0 = await methods.trigger();
      if (isValidStep0) {
        if (emailExists) {
          toast.error("Email already exists. Please use a different email.");
          return;
        }
        if (mobileExists) {
          toast.error(
            "Mobile number already exists. Please use a different mobile number."
          );
          return;
        }
        setActiveStep(newStep);
      } else {
        console.log(
          "Please fix validation errors before moving to the next step."
        );
      }
    } else if (newStep === 2) {
      const isValidStep1 = await methods.trigger();
      if (isValidStep1) {
        setActiveStep(newStep);
      } else {
        console.log(
          "Please fix validation errors before moving to the next step."
        );
      }
    } else {
      setActiveStep(newStep);
    }
  };

  if (loading) {
    return <Loader/>;
  }
  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="edit-all-loan-container">
      {activeStep === 0 && (
        <div className="edit-back-icon">
            <div 
                className="edit-back-text"
                onClick={() => navigate("/carloanlist")}>
                &lt; Go Back 
            </div>
        </div>
    )}
      <h2>Car Loan</h2>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            className="stepper-container"
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div className="form-content">
            {activeStep === 0 && (
              <div className="sections personal-details-sections">
                <h4>Personal Details</h4>
                <div className="form-row">
                  <LabeledInput
                    label="Employee ID"
                    name="created_id"
                    disabled={true}
                    style={{ backgroundColor: "#f0f0f0", color: "#808080" }}
                    registerOptions={{}}
                  />
                  <LabeledInput
                    label="Employee"
                    name="created_by"
                    disabled={true}
                    style={{ backgroundColor: "#f0f0f0", color: "#808080" }}
                    registerOptions={{}}
                  />
                </div>
                <div className="form-row">
                  {adminRole === "admin" && (
                    <LabeledSelect
                      name="assigned_to"
                      label="Assign to"
                      options={employeeOptions}
                      registerOptions={{ required: "Selection is required" }}
                      error={errors.assigned_to?.message}
                      required
                    />
                  )}
                  <LabeledDropDown
                    name="status"
                    label="Lead Status"
                    options={[
                      { value: "Open", label: "Open" },
                      { value: "In Process", label: "In Process" },
                      { value: "Pending", label: "Pending" },
                      { value: "Approved", label: "Approved" },
                      { value: "Rejected", label: "Rejected" },
                    ]}
                    registerOptions={{
                      required: "Selection is required",
                      onChange: (e) => {
                        handleStatusChange(e);
                        setValue("status", e.target.value); // Update status value in form
                      },
                    }}
                    error={errors.status?.message}
                    required
                  />
                  {watch("status") === "Rejected" && (
                    <LabeledDropDown
                      name="rejected_reason"
                      label="Rejected Reason"
                      options={[
                        {
                          value: "CIBIL issue & more than 3 enquiries",
                          label: "CIBIL issue & more than 3 enquiries",
                        },
                        {
                          value: "Recent loan/settlement",
                          label: "Recent loan/settlement",
                        },
                        { value: "Recent DPD", label: "Recent DPD" },
                        {
                          value: "Overdue / Previous loan (HL/PL/BL/CL)",
                          label: "Overdue / Previous loan (HL/PL/BL/CL)",
                        },
                        {
                          value: "Lowest CIBIL score",
                          label: "Lowest CIBIL score",
                        },
                        {
                          value: "Guarantor CIBIL score / Co-Applicant issue",
                          label: "Guarantor CIBIL score / Co-Applicant issue",
                        },
                        {
                          value: "Pincode / Salary / Age criteria not met",
                          label: "Pincode / Salary / Age criteria not met",
                        },
                        {
                          value: "Can apply after 3 months",
                          label: "Can apply after 3 months",
                        },
                        {
                          value: "Never eligible for loan",
                          label: "Never eligible for loan",
                        },
                        {
                          value: "Credit card overdue",
                          label: "Credit card overdue",
                        },
                      ]}
                      registerOptions={{ required: "Selection is required" }}
                      error={errors.rejected_reason?.message}
                      required
                    />
                  )}
                </div>
                <div className="form-row">
                  <LabeledInput
                    label="Name"
                    type="text"
                    name="name"
                    registerOptions={validationRules.name}
                    error={errors.name?.message}
                    required
                  />
                  <LabeledInput
                    label="Date of Birth"
                    type="date"
                    name="dob"
                    registerOptions={{
                      required: "Date of Birth is required",
                      validate: (value) => {
                        const today = new Date();
                        const dob = new Date(value);
                        const age = today.getFullYear() - dob.getFullYear();
                        const monthDifference =
                          today.getMonth() - dob.getMonth();

                        // Check if the birthday hasn't occurred yet this year
                        if (
                          monthDifference < 0 ||
                          (monthDifference === 0 &&
                            today.getDate() < dob.getDate())
                        ) {
                          return (
                            age > 21 || "You must be at least 21 years old."
                          );
                        }

                        return (
                          age >= 21 || "You must be at least 21 years old."
                        );
                      },
                    }}
                    error={errors.dob?.message}
                    required
                  />
                </div>
                <div className="form-row">
                  <LabeledInput
                    label="Email"
                    type="text"
                    name="email"
                    registerOptions={validationRules.email}
                    error={errors.email?.message}
                    required
                  />
                  <LabeledInput
                    label="Phone Number"
                    type="tel"
                    name="mobile"
                    registerOptions={validationRules.mobile}
                    error={errors.mobile?.message}
                    required
                  />
                </div>
                <div className="form-row">
                  <LabeledSelect
                    label="City"
                    type="text"
                    name="city"
                    options={cityOptions}
                    error={errors.city?.message}
                    required
                  />
                  <LabeledSelect
                    label="State"
                    type="text"
                    name="state"
                    options={stateOptions}
                    error={errors.state?.message}
                    required
                  />
                </div>
                <div className="form-row">
                  <LabeledSelectAgent
                    label="Pincode"
                    type="text"
                    name="pincode"
                    options={pincodeOptions}
                    registerOptions={validationRules.Pincode}
                    required
                  />
                  <LabeledDropDown
                    label="Marital Status?"
                    name="maritalstatus"
                    options={[
                      { value: "Single", label: "Single" },
                      { value: "Married", label: "Married" },
                      { value: "Separated", label: "Separated" },
                      { value: "Divorced", label: "Divorced" },
                      { value: "Widowed", label: "Widowed" },
                    ]}
                    registerOptions={{ required: "Status is required" }}
                    error={errors.maritalstatus?.message}
                    required
                  />
                </div>
                <div className="form-row">
                  <LabeledInput
                    label="Emergency Contact Phone"
                    type="tel"
                    name="emergency_contact_phone"
                  />
                  <LabeledInput
                    label="Address"
                    type="text"
                    name="current_address"
                    registerOptions={{ required: "Address is required" }}
                    error={errors.current_address?.message}
                    required
                  />
                  </div>

              </div>
            )}
            {activeStep === 1 && (
              <div className="sections financial-details-sections">
                 <h4>Loan Details</h4>
                  <div className="sections loan-details-sections">
                  <div className="form-row">
                  <LabeledDropDown
                    name="employee_type"
                    label="Employee Type"
                    options={[
                      { value: "salaried", label: "Salaried" },
                      { value: "self employed", label: "Self Employed" },
                    ]}
                    registerOptions={{ required: "Employee Type is required" }}
                  />
                    <LabeledDropDown
                      label="Loan Type"
                      name="loan_type"
                      options={[
                        { value: "Used Car", label: "Used Car" },
                        { value: "New Car", label: "New Car" },
                      ]}
                      registerOptions={{ required: "Loan Type is required" }}
                      error={errors.loan_type?.message}
                      required
                    />
                    </div>
                    <div className="form-row">
                    <LabeledInput
                      label="Requested Loan Amount"
                      type="number"
                      name="requested_loan_amount"
                      registerOptions={{ required: "Loan Amount is required" }}
                      error={errors.requested_loan_amount?.message}
                      required
                    />

                      <LabeledInput
                      label="Monthly Income"
                      type="number"
                      name="monthly_income"
                      registerOptions={{
                        required: "Monthly Net Income is required",
                      }}
                      error={errors.monthly_income?.message}
                      required
                    />
                     </div>
                    </div>
        
                  <div className="form-row">
                  <LabeledInput
                    label="Current Bank Name"
                    name="current_bank_name"
                    registerOptions={{
                      required: "Current Bank Name is required",
                    }}
                    error={errors.current_bank_name?.message}
                    required
                  />
                  <LabeledInput
                    label="Branch"
                    name="branch"
                    registerOptions={{ required: "Branch is required" }}
                    error={errors.branch?.message}
                    required
                  />
                </div>
                <div className="form-row">
                  <LabeledDropDown
                    name="account_type"
                    label="Account Type"
                    options={[
                      { value: "Savings", label: "Savings" },
                      { value: "Current", label: "Current" },
                    ]}
                    registerOptions={{ required: "Account Type is required" }}
                    error={errors.account_type?.message}
                    required
                  />
                  <LabeledInput
                    label="Account Number"
                    type="number"
                    name="account_number"
                    registerOptions={{ required: "Account Number is required" }}
                    error={errors.account_number?.message}
                    required
                  />
                </div>
                <div className="form-row">
                  <LabeledDropDown
                    label="Do you own a house?"
                    name="own_house"
                    options={[
                      { value: "Yes", label: "Yes" },
                      { value: "No", label: "No" },
                    ]}
                    registerOptions={{
                      required: "Current Loan status is required",
                    }}
                    error={errors.current_loan?.message}
                    required
                  />
                  <LabeledDropDown
                    label="Current Loan"
                    type="text"
                    name="current_loan"
                    options={[
                      { value: "Yes", label: "Yes" },
                      { value: "No", label: "No" },
                    ]}
                    registerOptions={{
                      required: "Current Loan status is required",
                    }}
                    error={errors.current_loan?.message}
                    required
                  />
                </div>

                <div className="sections vehicle-details-sections">
                <h4>Vehicle Details</h4>
                  <div className="form-row">
                    <LabeledInput
                      label="Make & Model"
                      name="make_model"
                      registerOptions={{ required: "Make & Model is required" }}
                      error={errors.make_model?.message}
                      required
                    />
                    <LabeledInput
                      label="Registered Year"
                      type="number"
                      name="registered_year"
                      registerOptions={{
                        required: "Registered Year is required",
                      }}
                      error={errors.registered_year?.message}
                      required
                    />
                  </div>
                  <div className="form-row">
                    <LabeledInput
                      label="Registration Number"
                      name="registration_number"
                      registerOptions={{
                        required: "Registration Number is required",
                      }}
                      error={errors.registration_number?.message}
                      required
                    />
                  </div>
                </div>

              </div>
            )}
            {activeStep === 2 && (
              <div className="sections financial-details-sections">
                <div className="form-row">
                  <div className="sections document-upload-sections">
                    <div className="document-upload-group">
                      <label htmlFor="pan_card" className="document-label">
                        PAN Card
                      </label>
                      <div className="document-file-container">
                        <input
                          label="PAN Card"
                          type="file"
                          name="pan_card"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                      </div>
                      <button
                        type="button"
                        className="view-btn"
                        onClick={() => handleViewClick("pan_card")}
                      >
                        View
                      </button>
                    </div>
                    <div className="document-upload-group">
                      <label htmlFor="aadhar_card" className="document-label">
                        Aadhar Card
                      </label>
                      <div className="document-file-container">
                        <input
                          label="aadhar_card Card"
                          type="file"
                          name="aadhar_card"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                      </div>
                      <button
                        type="button"
                        className="view-btn"
                        onClick={() => handleViewClick("aadhar_card")}
                      >
                        View
                      </button>
                    </div>
                    <div className="document-upload-group">
                      <label htmlFor="photo" className="document-label">
                        Photo
                      </label>
                      <div className="document-file-container">
                        <input
                          label="Photo"
                          type="file"
                          name="photo"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                      </div>
                      <button
                        type="button"
                        className="view-btn"
                        onClick={() => handleViewClick("photo")}
                      >
                        View
                      </button>
                    </div>
                    <div className="document-upload-group">
                      <label htmlFor="signature" className="document-label">
                        Signature
                      </label>
                      <div className="document-file-container">
                        <input
                          label="Signature"
                          type="file"
                          name="signature"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                      </div>
                      <button
                        type="button"
                        className="view-btn"
                        onClick={() => handleViewClick("signature")}
                      >
                        View
                      </button>
                    </div>
                    <div className="document-upload-group">
                      <div className="document-file-container">
                        <input
                          label="Co-Signer Signature"
                          type="file"
                          name="cosigner_signature"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                      </div>
                      <button
                        type="button"
                        className="view-btn"
                        onClick={() => handleViewClick("cosigner_signature")}
                      >
                        View
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="button-container">
            <Row className="mt-4">
              <Col className="text-end">
                {activeStep > 0 && (
                  <Button
                    variant="secondary"
                    onClick={() => handleStepChange(activeStep - 1)}
                    className="custom-back-button"
                  >
                    Go Back
                  </Button>
                )}
                {activeStep < steps.length - 1 && (
                  <Button
                    variant="primary"
                    onClick={() => handleStepChange(activeStep + 1)}
                    className="custom-next-button"
                  >
                    Next Step
                  </Button>
                )}
                {activeStep === steps.length - 1 && (
                  <Button
                    type="submit"
                    variant="success"
                    className="custom-submit-button"
                  >
                    Update
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        </form>
      </FormProvider>
      <ToastContainer />
    </div>
  );
};

export default EditCarLoan;
